import { graphql, Link } from 'gatsby';
import MetaTags from 'components/MetaTags';
import ProductCard from 'components/ProductCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';


const NotFoundPage = ({ data }) => {
  const { products } = data

  return (
    <>
      <MetaTags
        title="MixMeister | 404 Not found"
        description="Ah snap, we could not found the site you were searching for..."
      />
      <div className="container">
        <div className="row mt-5">
          <div className="col-md-12">
            <div className="error-template text-center">
              <h2>
                Oops!
              </h2>
              <h1 className="secondary-text-color">
                404 Not Found
              </h1>
              <div className="text-muted">
                Sorry, an error has occured, Requested page not found!
              </div>
              <div className="mt-4">
                <Link
                  to="/"
                  className="btn btn-lg btn-light"
                >
                  <FontAwesomeIcon icon={faHome} className="mr-2" />
                  Take me home
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 text-center mt-2 mb-5">
            <hr/>
            <h4 className="mt-5 mb-3 text-muted">
              ...or see some of our featured products down bellow
            </h4>
          </div>
        </div>
        <div className="row justify-content-center">
          {
            products.nodes
              .map(({ fileId, category, hero_image, title, meta, fastspring_id, featured }) => {
                const link = `/${category}/${fileId}.html`

                return (
                  <ProductCard
                    key={`${fileId}-${category}`}
                    link={link}
                    img={hero_image.src}
                    imgAlt={hero_image.alt}
                    title={title}
                    description={meta.description}
                    fastspringId={fastspring_id}
                    featured={featured}
                    category={category}
                  />
                )
              })
          }
        </div>
      </div>
    </>
  )
}

export const query = graphql`
    query {
        products: allProductsJson(filter: { featured: { eq: true }}) {
            nodes {
                title
                fileId
                fastspring_id
                featured
                meta {
                    description
                }
                hero_image {
                    src {
                        childImageSharp {
                            gatsbyImageData(
                                width: 340
                                height: 340
                                placeholder: BLURRED
                                formats: [AUTO, WEBP, AVIF]
                                transformOptions: {
                                    cropFocus: WEST
                                }
                            )
                        }
                    }
                }
            }
        }
    }
`

export default NotFoundPage
